import styled, { css } from "styled-components";

export const TabbedDisplay = styled.div`
  padding-top: 1rem;
`;

export const TabSection = styled.div`
  width: 100%;
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
`;

export const TabsWrapper = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.light};
  padding: 0.3rem;
  border-radius: 0.25rem 0.25rem 0 0;
`;

export const Tab = styled.div<{ $active: boolean }>`
  cursor: pointer;
  padding: 0.5rem 1.2rem;
  ${(props) =>
    props.$active &&
    css`
      background-color: ${(props) => props.theme.colors.accent1};
      color: ${(props) => props.theme.colors.lightest};
      border-radius: 0.25rem;
    `}
`;

export const ContentSection = styled.div`
  width: 100%;
  padding: 1rem 0;
`;
